/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import Body from 'DesignSystem/Body/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 2,
marginBottom: 8})

export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  value,
viewPath= "/App/MyAccount/Content/Profile/Content/Employees/Item/Content/Delete/Professional/Content/Delete/Content/MembersWillBeReassigned/Content"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'user.professional.members_aggregate.aggregate.count', 
context: 'user',
})
    

  return (<React.Fragment
>
<div
 data-testid="Content.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/Item/Content/Delete/Professional/Content/Delete/Content/MembersWillBeReassigned/Content"
 className={`views-block ${styles.Horizontal}`}
>
<Body
 data-testid="Content.Body"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/Item/Content/Delete/Professional/Content/Delete/Content/MembersWillBeReassigned/Content"
viewPath={`${viewPath}/Body`}
 text={data.value}
 marginRight={4}
/>
<Body
 data-testid="Content.Body:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/Item/Content/Delete/Professional/Content/Delete/Content/MembersWillBeReassigned/Content"
viewPath={`${viewPath}/Body`}
 text="members will not have a primary care dentist, but each will remain assigned to their current location."
/>
</div>
{children}
</React.Fragment>)
}